export default {
  intercomForcedCustomer: {
    id: 'care_platform_layer_health_banner_intercom_forced_customer',
    defaultMessage:
      "We're having technical issues, so conversations may be unavailable or delayed. Thanks for your patience while we fix it.",
  },
  intercomForcedAgent: {
    id: 'care_platform_layer_health_banner_intercom_forced_agent',
    defaultMessage:
      'Intercom is experiencing issues, so conversations may be delayed or unavailable.',
  },
  intercomForcedSeller: {
    id: 'care_platform_layer_health_banner_intercom_forced_seller',
    defaultMessage:
      "We're having technical issues, so conversations may be unavailable or delayed. Thanks for your patience while we fix it.",
  },
}
